import React, { Component } from 'react';
import { FetchDashboardCourses, fetchInformation } from '../services/dashboard_services';
import Dashboard from '../components/Dashboard';

class DashboardPage extends Component {
  state = {
    generalInformation: {},
    courses: [],
    loading: true,
  };

  componentDidMount() {
    Promise.all([
      this.fetchInformation(),
      this.FetchDashboardCourses(),
    ]).then(() => this.setState({ loading: false }));
  }

  updateInformation = () => {
    this.setState({ loading: true });
    Promise.all([
      this.fetchInformation(),
      this.FetchDashboardCourses(),
    ]).then(() => this.setState({ loading: false }));
  };

  fetchInformation = () => fetchInformation().then(response => this.setState({ generalInformation: response }));

  FetchDashboardCourses = () => FetchDashboardCourses().then(response => this.setState({ courses: response }));

  render() {
    const {
      generalInformation, loading, courses,
    } = this.state;

    return (
      <Dashboard
        generalInformation={generalInformation}
        loading={loading}
        courses={courses}
        onUpdate={this.updateInformation}
      />
    );
  }
}

export default DashboardPage;
